import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { clearPbiInfo, getContentByGroupId } from './actions/content/content.actions';
import VCard from './VCard';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';

//WIP: BIFUR
const DetailPage = ({ params, location }) => {
  const eventInfo = location?.state?.eventInfo;
  const { groupId } = params;
  const dispatch = useDispatch();
  const claroLiteConfig = useSelector(selectMetadataKeyByRegion("cv_advertising_config"))

  useEffect(
    () => {
      if (!groupId || groupId === '') return;
      //TODO: CV lite
      dispatch(getContentByGroupId(groupId, claroLiteConfig?.enable));
      // dispatch(getContentByGroupId(groupId, false));
    },
    [groupId],
  );
  useEffect(()=>{

    return ()=>{
      dispatch(clearPbiInfo())
    }

  },[])

  return <VCard groupId={groupId} isActive isStatic eventInfo={eventInfo} />;
};

DetailPage.propTypes = {
  params: PropTypes.shape({
    groupId: PropTypes.string,
  }).isRequired,
  location: PropTypes.object,
};
export default DetailPage;
